import { render, staticRenderFns } from "./Fail.vue?vue&type=template&id=ea42e0fa&scoped=true"
import script from "./Fail.vue?vue&type=script&lang=js"
export * from "./Fail.vue?vue&type=script&lang=js"
import style0 from "./Fail.vue?vue&type=style&index=0&id=ea42e0fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea42e0fa",
  null
  
)

export default component.exports